<div class="modal-header">
    <h4 class="modal-title fw-bold"></h4>
    <button type="button" class="btn-close"
            (click)="closeModal()">
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-12">
            @if (isLoadingFlapjack) {
                <div>
                    <span  class="throbber"></span><span>&nbsp;{{'genotyping.system.fetching.from.server' | translate}}</span>
                </div>
            }
            <div id="flapjack-div" ref="bytes"></div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModal()">{{ 'close' | translate}}</button>
</div>
